var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUDownLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 8.4375L2.25 11.8125M2.25 11.8125L5.625 15.1875M2.25 11.8125H11.8125C12.3296 11.8125 12.8416 11.7107 13.3193 11.5128C13.797 11.3149 14.2311 11.0249 14.5967 10.6592C14.9624 10.2936 15.2524 9.85954 15.4503 9.38182C15.6482 8.9041 15.75 8.39208 15.75 7.875C15.75 6.83071 15.3352 5.82919 14.5967 5.09077C13.8583 4.35234 12.8568 3.9375 11.8125 3.9375H5.625",
    stroke: "#541FF3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUDownLeft);
export default __webpack_public_path__ + "static/media/ArrowUDownLeft.95f6c16fb2e7328d6eac0705f6a9b8ba.svg";
export { ForwardRef as ReactComponent };